import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { newGuid } from "helpers/guid";
import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import { Minus } from "UI/Icons";
import { FlexibleTextArea } from "UI/Inputs";
import MatrixGradeStep from "./MatrixGradeStep";

var MatrixBlock = /*#__PURE__*/function (_Component) {
  _inherits(MatrixBlock, _Component);

  var _super = _createSuper(MatrixBlock);

  function MatrixBlock(props) {
    var _this;

    _classCallCheck(this, MatrixBlock);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onStepAdd", function (event) {
      event.preventDefault();
      var cells = _this.state.cells;
      var id = newGuid();
      var keyId = newGuid();
      cells.push({
        id: id,
        keyId: keyId,
        text: ""
      });

      _this.setState({
        cells: cells
      }, function () {
        _this.sendToParagraph();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStepUpdate", function (blockStep) {
      var cells = _this.state.cells;
      var step = cells.find(function (t) {
        return t.id == blockStep.id;
      });
      step.text = blockStep.text;

      _this.setState({
        cells: cells
      }, function () {
        _this.sendToParagraph();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStepDelete", function (blockStep) {
      var cells = _this.state.cells;
      cells = cells.filter(function (t) {
        return t.id != blockStep.id;
      });

      _this.setState({
        cells: cells
      }, function () {
        _this.sendToParagraph();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeBlockTitle", function (text) {
      _this.setState({
        text: text
      }, function () {
        _this.sendToParagraph();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBlockDelete", function () {
      _this.props.onBlockDelete({
        id: _this.props.block.id
      });
    });

    _defineProperty(_assertThisInitialized(_this), "sendToParagraph", function () {
      _this.props.onBlockUpdate({
        id: _this.props.block.id,
        text: _this.state.text,
        cells: _this.state.cells
      });
    });

    _this.state = {
      id: props.block.id != null ? props.block.id : newGuid(),
      text: props.block.text != null ? props.block.text : "",
      cells: props.block.cells != null ? props.block.cells : []
    };
    return _this;
  }

  _createClass(MatrixBlock, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          padding: "0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flexGrow: "1"
        }
      }, /*#__PURE__*/React.createElement(FlexibleTextArea, {
        value: this.state.text != null ? this.state.text : "",
        placeholder: this.props.translate("text"),
        onChange: function onChange(event) {
          return _this2.onChangeBlockTitle(event.target.value);
        }
      })), /*#__PURE__*/React.createElement("div", {
        onClick: this.onBlockDelete,
        style: {
          flexShrink: "0",
          cursor: "pointer",
          margin: "0 1em",
          marginLeft: "3em"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: "15px",
          display: "inline-block",
          position: "relative",
          top: "2px",
          marginRight: "0.5em"
        }
      }, /*#__PURE__*/React.createElement(Minus, null)), this.props.translate("delete-block"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%",
          display: "flex",
          alignItems: "flex-start"
        }
      }, this.state.cells.map(function (blockStep) {
        var key = blockStep.keyId ? blockStep.keyId : blockStep.id;
        return /*#__PURE__*/React.createElement(MatrixGradeStep, {
          key: key,
          blockStep: blockStep,
          onStepUpdate: _this2.onStepUpdate.bind(_this2),
          onStepDelete: _this2.onStepDelete.bind(_this2)
        });
      }, this), /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          flex: "1 1 0%",
          padding: "0",
          position: "relative",
          marginTop: "1em",
          marginRight: "2em",
          fontSize: "1em"
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "courses-add-btn",
        onClick: this.onStepAdd
      }, this.props.translate("add-step")))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })));
    }
  }]);

  return MatrixBlock;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {})(MatrixBlock);